const environment = import.meta.env.MODE;
//console.log(`target: ${environment}`);

export const networkUrl = 'http://' + (globalThis?.window?.__NETWORK_URL__ ?? 'localhost');
//console.log(`networkUrsdl: ${networkUrl} `);

export const apiDomain: string =
  environment === 'production' ? 'https://portfolio.robotop.de' : networkUrl + ':3000';
export const websiteDomain: string =
  environment === 'production' ? 'https://portfolio.robotop.de' : networkUrl + ':5173';

export const serverPath: string = `${apiDomain}/api/`;
const cdnPath: string = `${serverPath}public/`;

export const userPath: string = `${serverPath}user/`;
export const cdnCompanyLogos: string = `${cdnPath}companyLogos/`;
export const cdnLayoutImages: string = `${cdnPath}layoutImg/`;
export const cdnLayoutImagesThumb: string = `${cdnPath}layoutImgThumb/`;
export const cdnPreviewImages: string = `${cdnPath}modelImg/`;
export const cdnPreviewImagesThumb: string = `${cdnPath}modelImgThumb/`;
export const cdnAppLogos: string = `${cdnPath}appLogos/`;
export const productPath: string = `${serverPath}product/`;
export const layoutPath: string = `${serverPath}layout/`;
export const listingPath: string = `${serverPath}listing/`;
export const appPath: string = `${serverPath}app/`;
export const projectPath: string = `${serverPath}project/`;
export const notificationPath: string = `${serverPath}notification/`;
export const ecomPath: string = `${serverPath}ecom/`;
/** Unity WebGL build URLs embedded by the App (stable) and App Beta (dev) pages. */
export const ecomAppUrl: string = `${ecomPath}app`;
export const ecomAppBetaUrl: string = `${ecomPath}app/dev`;
export const gameServerPath: string =
  environment === 'production'
    ? `${serverPath}gameServer/`.replace('http', 'ws')
    : apiDomain.replace(/^http/, 'ws');

/** Colyseus endpoint — uses current browser host in dev (avoids IP mismatch). */
export function getGameServerPath(): string {
  if (environment === 'production') {
    return `${serverPath}gameServer/`.replace('http', 'ws');
  }
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const port = 3000;
    return `ws://${host}:${port}`;
  }
  return apiDomain.replace(/^http/, 'ws');
}

export const clientRoutes = {
  ecom: '/ecom',
  ecomBeta: '/ecom/beta',
  ecomAdmin: '/ecom/admin',
  masterAdmin: '/platform/admin',
  home: '/',
  compare: '/compare',
  account: '/account',
  dashboard: '/dashboard',
  product: '/product/:id',
  layout: '/layout/:id',
  user: '/user/:username',
  embed: '/embed/:id',
  editproduct: '/editproduct',
  createproduct: '/createproduct',
  demoRoom: '/demoroom',
  portfolioVerse: '/map',
  academy: '/academy',
  signup: '/signup',
  login: '/login',
  loginVerifyEmail: '/login/verify-email',
  loginResetPassword: '/login/reset-password',
  loginReturn: '/login/return',
  accountChangePassword: '/account/change-password',
  dropshipping: '/lp/dropshipping',
  ssoDemo: '/dev/sso-demo',
  partnerGuide: '/guides/partner-integration',
  patchNotes: 'https://portfolio-rbtp.notion.site/ebd/20e13aadde448076981dc395a90f481d',
};
